import { createSlice } from '@reduxjs/toolkit';
import { postOptions } from '../../enums/enums';

const defaultPayload = {
  useSubgroups: true,
  dateRegFrom: null,
  dateRegTo: null,
  onlineBefore: null,
  onlineAfter: null,
  refCode: null,
  hasUnreadMsg: 'skip',
  pressAnyKey: 'skip',
  isDepositLock: 'skip',
  hasInputInvoice: 'skip',
  hasDeposit: 'skip',
  runGame: 'skip',
  regType: 'skip',
  botDeleted: 'skip',
  userStatus: 'skip',
  hasPhoneNum: 'skip',
  userType: 'skip',
  onlineStatus: 'skip',
  userLogin: null,
  userId: null,
  depositCurrency: 'skip',
  depositAmountFrom: 0,
  depositAmountTo: 0,
  depositDateFrom: null,
  depositDateTo: null,
  pageNo: 1,
  pageSize: postOptions[0].value
};

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    list: {
      defaultPayload: defaultPayload,
      payload: defaultPayload,
      totalUsers: '',
      result: [],
      selectUser: {}
    }
  },
  reducers: {
    setUsersPayload: (state, action) => {
      state.list.payload = action.payload;
    },
    resetUsers: (state, action) => {
      state.list.payload = defaultPayload;
      state.list.totalUsers = '';
      state.list.result = [];
      state.list.selectUser = {};
    },
    setUsersResult: (state, action) => {
      state.list.result = action.payload;
    },
    updateUserResult: (state, action) => {
      const { id, dataIndx, value } = action.payload;

      const user = state.list.result.find((el) => el[0] === id);
      if (user) user[dataIndx] = value;

      // const newResult = [...state.list.result];
      // const indxUpdated = newResult.findIndex((el) => el[0] == id);

      // if (indxUpdated !== -1) {
      //   newResult[indxUpdated][dataIndx] = value;
      //   state.list.result = newResult;
      // }
    },
    setSelectUser(state, action) {
      state.list.selectUser = action.payload;
    },
    setDeleteUser(state, action) {
      const idsToDelete = action.payload; // Массив ID для удаления
      state.list.result = state.list.result.filter((user) => !idsToDelete.includes(user[0]));
      const newTotalUser = state.list.totalUsers - idsToDelete.length;
      if (newTotalUser || newTotalUser == 0) state.list.totalUsers = newTotalUser;
    },
    setTotalUsers(state, action) {
      state.list.totalUsers = action.payload;
    }
  }
});

export default usersSlice.reducer;

export const {
  setUsersPayload,
  setUsersResult,
  updateUserResult,
  setSelectUser,
  setDeleteUser,
  resetUsers,
  setTotalUsers
} = usersSlice.actions;
